import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddTransshipmentMutation } from "store/services/transhipmentApi";

import TransshipmentForm from "./TranshipmentController/TransshipmentForm";

import { useAppMeta } from "hooks";

const TransshipmentCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Transshipment", path: "/app/crm/transshipment/list" },
    { title: "New Transshipment" }];

  const [createTransshipment, { isLoading: creatingTransshipment }] =
    useAddTransshipmentMutation();

  // methods
  const handleAddSTransshipment = async (data) => {

    try {
      const { _id } = await createTransshipment(data).unwrap();
      toast.success("Transshipment Created !");
      navigate(`/app/crm/transshipment/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Transshipment !"
      );
    }
  }
  useAppMeta("New Transshipment");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingTransshipment}>
      <BreadcrumbLayout.Paper>
        <TransshipmentForm isBusy={creatingTransshipment} onSubmit={handleAddSTransshipment} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default TransshipmentCreateScreen